import KColorSwatch from "./KColorSwatch";
import KValidatableInput from "./KValidatableInput";
import {
	VCard,
	VCardTitle,
	VCol,
	VContainer,
	VDialog,
	VMenu,
	VRow
} from "vuetify/lib";

export default {
	name: "KColorSwatchPicker",

	extends: KValidatableInput,

	props: {
		colors: {
			default: () => [
				"#E53935",
				"#F06292",
				"#7E57C2",
				"#2196F3",
				"#00695C",
				"#66BB6A",
				"#FF9800",
				"#FF5722",
				"#795548",
				"#607D8B",
				"#757575",
				"#000"
			],
			type: Array
		},

		title: {
			default: "Select a Color",
			type: String
		},

		value: {
			default: null,
			type: String
		}
	},

	data: () => ( {
		open: false
	} ),

	computed: {
		internalColor() {
			if ( this.value ) {
				return this.value;
			}

			if ( this.dark ) {
				return "#FFF";
			}

			return "#000";
		},

		internalValue: {
			get() {
				return this.value;
			},

			set( val ) {
				this.$emit( "input", val );
			}
		},

		genColorPicker() {
			const TagName = this.$vuetify.breakpoint.smAndDown ? VDialog : VMenu;

			return <TagName
				bottom
				closeOnContentClick={false}
				fullWidth
				maxWidth={260}
				minWidth={260}
				offsetY
				scopedSlots={{
					activator: ( { on } ) =>
						<div on={on}>{this.genValidationProvider()}</div>
				}}
				vModel={this.open}
			>
				<VCard>
					<VCardTitle class="primary text-subtitle-1 white--text">
						{this.title}
					</VCardTitle>

					<VContainer fluid>
						<VRow>
							{this.colors.map( color =>
								<VCol cols="3">
									<KColorSwatch
										color={color}
										onClick={() => this.save( color )}
										selected={this.internalValue === color}
									></KColorSwatch>
								</VCol>
							)}
						</VRow>
					</VContainer>
				</VCard>
			</TagName>;
		}
	},

	methods: {
		save( color ) {
			this.internalValue = color;
			this.open = false;
		},

		genValidatableField() {
			return <KColorSwatch
				class="mr-2"
				color={this.internalColor}
				vModel={this.internalValue}
			></KColorSwatch>;
		},

		genDefaultSlot() {
			return [
				this.genColorPicker,
				this.genLabel()
			];
		}
	}
};
